module.exports = __webpack_public_path__ + "static/img/title@1x.a9bd0ded.svg";